import { render, staticRenderFns } from "./additional-treatments.vue?vue&type=template&id=d3923418&"
import script from "./additional-treatments.vue?vue&type=script&lang=js&"
export * from "./additional-treatments.vue?vue&type=script&lang=js&"
import style0 from "./additional-treatments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports